import React, { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import styles from '../data-object/summary-card.module.sass';
import { DataObjectType, ObjectProperty } from '../../model/data';
import { ReRenderItemContext } from './dataSource';
import { SaveAllControllerContext, useSaveAllController } from '../use-save-all-controller';
import { DataObjectComponent } from '../data-object';
import { complexPropertyTypes } from '../data-object/data-object-component';


export interface DataSourceRenderProps {
    dataObject: ObjectProperty;
    reRenderItem: () => void;
}

export const DataSourceRender: FC<DataSourceRenderProps> = observer((props) => {

    const saveAllController = useSaveAllController();

    const playerProperties = props.dataObject.value.filter(value => !complexPropertyTypes.includes(value.type)).filter(value => !(value.label.toLowerCase() === 'view' && value.type === DataObjectType.urlLink));
    const topLevelProperties = props.dataObject.value.filter(value => complexPropertyTypes.includes(value.type));

    const [activeCard, setActiveCard] = useState<string>(props.dataObject.label.toLowerCase());

    const topLevelPropertyCard = (property: ObjectProperty) => {
        return <Card key={property.id}
                     className={`${styles.dataObjectCard} ${activeCard == property.label.toLowerCase() ? 'active' : ''}`}
                     onClick={() => setActiveCard(property.label.toLowerCase())}>
            <Card.Body className={styles.cardBody}>
                <Card.Title className={styles.cardTitle}>
                    {property.label}
                </Card.Title>
                <Card.Subtitle
                    className={styles.cardSubtitle}>{property.label.toLowerCase() === 'player' ? playerProperties.length : property.value.length} properties</Card.Subtitle>

                {/*<div className={styles.horizontalListItems}>*/}
                {/*    {property.value.map(value =>*/}
                {/*        <span>{value.label}</span>*/}
                {/*    )}*/}
                {/*</div>*/}
            </Card.Body>
        </Card>;
    };

    const buildDataAndRoute = () => {

        const playerDataObject = {
            type: props.dataObject.type,
            id: props.dataObject.id,
            label: props.dataObject.label,
            isEditable: props.dataObject.isEditable,
            editorLevel: props.dataObject.editorLevel,
            isRequired: props.dataObject.isRequired,
            value: playerProperties
        } as ObjectProperty;

        if (activeCard == 'player') {
            return {
                route: [],
                dataObject: playerDataObject,
                playerIsLocked: false
                // playerIsLocked: !playerDataObject.isEditable
            };
        } else {
            return {
                route: [playerDataObject],
                dataObject: props.dataObject.value.find(value => value.label.toLowerCase() === activeCard) as ObjectProperty,
                playerIsLocked: false
                // playerIsLocked: !playerDataObject.isEditable
            };
        }
    };

    const componentData = buildDataAndRoute();

    return (
        <Container fluid>
            <Row>
                <Col xl={4} lg={5} md={6} className={styles.scrollable}>
                    {topLevelPropertyCard(props.dataObject)}
                    {topLevelProperties.map(property => topLevelPropertyCard(property as ObjectProperty))}
                </Col>
                <Col xl={8} lg={7} md={6} className={`${styles.scrollable} ${styles.playerCardCol}`}>
                    <Card className={styles.playerCardWrapper}>
                        <Card.Body className={styles.cardBody}>
                            {!!activeCard &&
                                <ReRenderItemContext.Provider value={props.reRenderItem}>
                                    <SaveAllControllerContext.Provider value={saveAllController}>
                                        <DataObjectComponent
                                            route={componentData.route}
                                            dataObject={componentData.dataObject}
                                            playerIsLocked={componentData.playerIsLocked}
                                        />
                                    </SaveAllControllerContext.Provider>
                                </ReRenderItemContext.Provider>
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
});
